<template>
    <DModal
        v-if="errorMessage !== null"
        :show="showModal"
        :title="__('customers.contracts.delete_tree_confirm_title')"
        :message="errorMessage"
        is-error
        @update:show="$emit('update:showModal', $event)"
        @close="$emit('close-modal')"
    />
    <DModal
        v-else
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.contracts.delete_tree_confirm_title')"
        :message="message"
        is-confirm
        is-error
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        @update:show="$emit('update:showModal', $event)"
        @confirm="deleteTreeContractConfirm"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'DeleteTreeContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        redirectTo: {
            type: String,
            default: 'contract-list'
        },
        errorMessage: {
            type: String,
            default: null
        },
        message: {
            type: String,
            default: ''
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            activity_log_comment: ''
        }
    },
    methods: {
        deleteTreeContractConfirm () {
            this.$inertia.post(this.$route('customers.customers.contracts.delete-tree-contract', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                redirectTo: this.redirectTo,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        }
    }
}
</script>
